module.exports = __webpack_public_path__ + "static/media/Usersnew.71c07b75.svg";